<template>
  <div>
    <trade-form-detail
      v-if="trade_detail_form.flag && home"
      :trade_detail_form="trade_detail_form"
      @reload-home-trade="$emit('reload-home-trades')"
      @reload-home="$emit('reloadTradesHome')"
    >
    </trade-form-detail>
    <confirm-trade-delete-form
      v-if="delete_data.flag"
      @delete-trade="$emit('delete-trade')"
      :delete_data="delete_data"
    ></confirm-trade-delete-form>

    <trade-form
      @tradeUpdated="$emit('reloadForm')"
      v-if="trade_form_data.flag"
      :trade_form_data="trade_form_data"
    ></trade-form>
    <v-card class="pb-4">
      <v-card-text
        style="border-bottom: 1px solid rgba(51, 51, 51, 0.12)"
        v-if="trade_data.copy_origin"
      >
        <div>
          <div class="copyText">
            Originally Posted by
            <span class="copyMainText">{{ trade_data.copy_origin_name }}</span>
          </div>
        </div>
      </v-card-text>
      <v-card-text style="background-color: #f6f7fa">
        <trade-user-data-group-row
          :trade="trade_data"
        ></trade-user-data-group-row>

        <div
          class="d-flex"
          v-if="is_user_content && trade_data.visibility !== 'group'"
        >
          <img
            class="profile-pic"
            :src="getImg(trade_data.user_image)"
            alt=""
            v-if="trade_data.user_image"
          />
          <v-avatar
            :class="
              $vuetify.breakpoint.xsOnly
                ? 'profile_avatar'
                : 'profile__pic__avatar'
            "
            style="background-color: lightblue"
            v-if="!trade_data.user_image"
          >
            <span style="color: #333333; font-weight: 700; font-size: 20px">
              {{ trade_data.posted_by_name | reduceToInitials }}
            </span>
          </v-avatar>
          <div class="user-title">
            <h2
              @click="goToProfile($event, trade_data.posted_by_name)"
              class="user__title"
              :class="$vuetify.breakpoint.smAndUp ? 'pt-2' : 'pt-1'"
            >
              {{ trade_data.posted_by_name }}
              <img
                @mouseover="tooltip = true"
                @mouseout="tooltip = false"
                id="sebi-badge"
                :src="sebi_badge"
                alt=""
                v-if="trade_data.is_sebi_registered"
                style="margin-bottom: -5px"
              />
              <p id="sebi-tooltip" v-if="tooltip">SEBI Registered</p>
            </h2>
            <div
              v-if="trade_data.is_sebi_registered"
              style="color: rgba(51, 51, 51, 0.54)"
            >
              <Disclaimer>
                <strong style="color: black"> SEBI certified influencer</strong>
              </Disclaimer>
            </div>
            <!-- <br v-if="trade_data.is_sebi_registered" /> -->
            <div style="color: rgba(51, 51, 51, 0.54)">
              {{ trade_data.created | formatTimestamp }}
            </div>
          </div>
          <div v-if="!is_same_user">
            <v-btn
              small
              class="px-6 py-3"
              color="primary"
              :text="isFollowingUser"
              @click="
                isFollowingUser
                  ? unFollowUser(trade_data.posted_by_id)
                  : followUser(trade_data.posted_by_id)
              "
            >
              <span
                style="font-weight: 800; font-size: 14px"
                class="text-capitalize"
              >
                {{ isFollowingUser ? "Following" : "Follow" }}
              </span>
            </v-btn>
          </div>
        </div>
      </v-card-text>
      <v-divider v-if="showDivider"></v-divider>
      <v-card-text class="py-1" @click="viewTrade(trade_data.id, '')">
        <div class="d-flex pt-2">
          <div class="title-span">
            <div>{{ trade_data.security_name }}</div>
            <div
              style="
                padding-top: 10px;
                font-size: 12px;
                color: rgba(51, 51, 51, 0.64);
              "
            >
              {{ trade_data.security_symbol }} :
              {{ trade_data.security_exchange }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <div class="text-right align-right">
            <div class="mr-1 live-price">₹ {{ trade_data.live_price }}</div>
            <div
              class="mr-1"
              style="white-space: nowrap; font-size: 13px"
              :class="incrementDecrementData > 0 ? 'increment' : 'decrement'"
            >
              <v-icon
                small
                :color="incrementDecrementData > 0 ? '#27AE60' : '#EB5757'"
                >{{ incrementDecrementIcon }} </v-icon
              >₹{{ Math.abs(incrementDecrementData) }}
              <span
                class=""
                :class="
                  profitLossPercent > 0 ? 'profit-percent' : 'loss-percent'
                "
                >({{ Math.abs(profitLossPercent) }}%)</span
              >
            </div>
          </div>
        </div>
        <div>
          <div class="d-flex py-1">
            <div>
              <span
                class="custom-chip-buy"
                v-if="trade_data.trade_type === 'Buy'"
              >
                Buy
              </span>
              <span
                class="custom-chip-sell"
                v-if="trade_data.trade_type === 'Sell'"
              >
                Sell
              </span>
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-chip :class="setChipClass"
                >{{ tradeStatusText }}
                <v-tooltip
                  content-class="tooltip"
                  color="#F7FAFF"
                  right
                  max-width="300"
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                    style="opacity: 1 !important"
                  >
                    <v-icon
                      :color="infoIconColor"
                      class="pl-2"
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <span class="tooltip-text">{{ statusContent }}<br /></span>
                </v-tooltip>
              </v-chip>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-text class="py-1">
        <v-row v-if="trade_data.target_stop_loss_list.length > 1">
          <v-col class="pa-1">
            <TradeTralingTargets
              :target_stop_loss_list="trade_data.target_stop_loss_list"
              :trade_type="trade_data.trade_type"
              :live_price="parseFloat(trade_data.live_price)"
              :entry_price="trade_data.entry_price.toFixed(2)"
              :exit_price="trade_data.exit_price.toFixed(2)"
              :profit_percent="trade_data.profit_percent"
              :status="trade_data.status"
              :duration_type="trade_data.duration_type"
              :duration_name="trade_data.duration_name"
              :pl_data="trade_data.pl_data"
              :stop_loss="trade_data.stop_loss"
              :target_price="trade_data.target_price"
              :pl_percent="trade_data.pl_percent"
            />
          </v-col>
        </v-row>
        <v-row v-else class="pt-4">
          <v-col
            cols="4"
            class="text-left"
            :class="$vuetify.breakpoint.xsOnly ? 'pl-3' : 'pl-3'"
          >
            <div class="price-span">Entry Price</div>
            <div class="new-figure">
              ₹{{ trade_data.entry_price.toFixed(2) }}
            </div>
          </v-col>
          <v-col
            cols="4"
            class="text-left"
            :class="$vuetify.breakpoint.xsOnly ? 'pl-8' : 'pl-10'"
          >
            <div class="price-span">Target Price</div>
            <div class="new-figure">
              ₹{{ trade_data.target_price.toFixed(2) }}
            </div>
          </v-col>
          <v-col
            cols="4"
            class="text-left"
            :class="$vuetify.breakpoint.xsOnly ? 'pl-7' : 'pl-10'"
          >
            <div class="price-span">Stop Loss</div>
            <div class="new-figure">₹{{ trade_data.stop_loss.toFixed(2) }}</div>
          </v-col>
          <v-col
            cols="5"
            sm="4"
            class="text-left pt-2"
            :class="$vuetify.breakpoint.xsOnly ? 'pl-3' : 'pl-3'"
          >
            <div class="price-span">
              {{ pandlTitle }}
              <v-tooltip
                max-width="300"
                content-class="tooltip"
                color="#F7FAFF"
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small class="pb-1 pl-1"
                    >mdi-information-outline
                  </v-icon>
                </template>
                <span class="tooltip-text">{{ pandlContent }}</span>
              </v-tooltip>
            </div>
            <v-chip
              class="figure"
              :color="pl_dataPercent > 0 ? '#27AE601F' : '#EB57571F'"
              :class="
                $vuetify.breakpoint.xsOnly
                  ? `pl-box-small ${trade_pandl_data}`
                  : `pl-box-large ${trade_pandl_data}`
              "
            >
              <v-icon small :color="pl_dataPercent > 0 ? '#27AE60' : '#EB5757'">
                {{ pl_dataIcon }}
              </v-icon>
              <span
                >₹{{ Math.abs(trade_data.pl_data) }}({{
                  trade_data.pl_percent
                }}%)</span
              >
            </v-chip>
          </v-col>
          <v-col
            cols="6"
            sm="4"
            class="pt-2"
            :class="
              $vuetify.breakpoint.xsOnly ? 'text-left px-1' : 'text-left pl-10'
            "
          >
            <div class="price-span">
              Duration
              <v-tooltip
                max-width="300"
                content-class="tooltip text-center black--text"
                color="#F7FAFF"
                right
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" small class="pb-1 pl-1">
                    mdi-information-outline
                  </v-icon>
                </template>

                <span
                  class="tooltip-text black--text"
                  v-for="item in trade_data.duration_type"
                  :key="item.id"
                >
                  {{ item.name }} <br />
                </span>
              </v-tooltip>
            </div>
            <div class="font-weight-black" style="color: #333333">
              {{ trade_data.duration_name }}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text
        class="py-2"
        v-if="trade_data.reasoning && trade_data.reasoning.content"
      >
        <div>
          <div class="reason d-flex">
            <LinkPreview
              v-if="trade_data.reasoning.content"
              :preview_url="getUrl(trade_data.reasoning.content)"
            ></LinkPreview>
          </div>
          <div>
            <span
              v-linkified
              v-if="home && trade_data.reasoning.content.length > 80"
            >
              {{ trade_data.reasoning.content.slice(0, 80) }}...
              <span
                @click="viewTrade(trade_data.id, 'trade_detail_show_more')"
                v-if="trade_data.reasoning.content.length > 80 && home"
                style="
                  color: #2d8cff;
                  text-decoration: underline;
                  cursor: pointer;
                "
              >
                Show more
              </span>
            </span>
            <span v-else>
              {{ trade_data.reasoning.content }}
            </span>
          </div>
        </div>
      </v-card-text>
      <v-card-actions v-if="show_button || home">
        <v-row>
          <v-col cols="12" class="px-4 pt-4 d-flex">
            <v-btn
              class="text-capitalize py-5 btnClass ml-0"
              color="#2d8cff"
              inner-height="40"
              :width="$vuetify.breakpoint.xsOnly ? '42%' : '50%'"
              v-if="isTradeLive && is_same_user"
              :loading="exitBtnLoader"
              @click="exitTradeHandler(trade_data)"
            >
              <span> Exit Trade </span>
            </v-btn>

            <v-btn
              class="text-capitalize py-5 btnClass ml-0"
              color="#2d8cff"
              inner-height="40"
              v-else-if="is_posted_by_user"
              :width="$vuetify.breakpoint.xsOnly ? '42%' : '50%'"
              @click="viewTrade(trade_data.id, 'trade_detail_comment')"
            >
              <span> view trade </span>
            </v-btn>
            <v-btn
              class="text-capitalize py-5 btnClass ml-0"
              color="#2d8cff"
              inner-height="40"
              v-else
              :width="$vuetify.breakpoint.xsOnly ? '42%' : '50%'"
              @click="copyTrade(trade_data)"
            >
              <span v-text="'Trade'"> </span>
            </v-btn>
            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-capitalize ml-3"
              v-if="!is_same_user"
              :loading="watchlistLoader"
              @click="followTrade()"
            >
              <v-icon
                :color="
                  trade_data.is_follower ? '#2d8cff' : 'rgba(51, 51, 51, 0.7)'
                "
                >mdi-playlist-plus</v-icon
              >
            </v-btn>
            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-capitalize ml-3"
              :loading="featuredBtnLoader"
              v-else
              @click="addOrRemoveToFeatured(trade_data)"
            >
              <v-icon color="#F2C94C" small v-if="trade_data.is_featured"
                >mdi-star</v-icon
              >
              <v-icon color="rgba(51, 51, 51, 0.7)" small v-else
                >mdi-star-outline</v-icon
              >
            </v-btn>
            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-capitalize"
              :class="$vuetify.breakpoint.smAndUp ? 'ml-3' : 'ml-3'"
              @click="viewTrade(trade_data.id, 'trade_detail_comment')"
            >
              <v-icon class="pa-1" color="rgba(51, 51, 51, 0.7)" small
                >mdi-comment-multiple-outline</v-icon
              >
              <span style="color: rgba(51, 51, 51, 0.7)">
                {{ trade_data.comments_count }}
              </span>
              <!-- <span
                style="color: rgba(51, 51, 51, 0.7)"
                v-if="$vuetify.breakpoint.smAndUp"
                >comments</span
              > -->
            </v-btn>
            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-capitalize"
              :class="$vuetify.breakpoint.smAndUp ? 'ml-3' : 'ml-3'"
              width="22%"
              v-if="$vuetify.breakpoint.smAndUp"
              inner-height="40"
              @click="
                shareTrade(
                  trade_data.id,
                  trade_data.posted_by_name,
                  trade_data.trade_type,
                  trade_data.security_name,
                  trade_data.posted_by_id
                )
              "
            >
              <v-icon
                class="pa-1"
                color="#2D8CFF"
                :small="$vuetify.breakpoint.smAndUp"
                >mdi-share-variant</v-icon
              >
              <span style="color: #2d8cff" v-if="$vuetify.breakpoint.smAndUp"
                >share</span
              >
            </v-btn>
            <v-menu offset-y v-if="$vuetify.breakpoint.xsOnly">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  height="40"
                  class="py-5 ml-1"
                  style="min-width: 0px !important; padding: 0 0px !important"
                >
                  <v-icon color="#2d8cff">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-title
                    @click="
                      shareTrade(
                        trade_data.id,
                        trade_data.posted_by_name,
                        trade_data.trade_type,
                        trade_data.security_name,
                        trade_data.posted_by_id
                      )
                    "
                    >Share</v-list-item-title
                  >
                </v-list-item>
                <v-list-item>
                  <v-list-item-title
                    @click="
                      toggleBlockUser({
                        show: true,
                        block_by: loggedInProfile.profile_id,
                        block_to: profile_object.id,
                      })
                    "
                    >Report & Block User</v-list-item-title
                  >
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            class="pt-3 px-2 d-flex"
            v-if="show_button && is_same_user"
          >
            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-capitalize"
              :class="$vuetify.breakpoint.smAndUp ? 'ml-3' : 'ml-3'"
              :width="$vuetify.breakpoint.xsOnly ? '18%' : '23%'"
              inner-height="40"
              v-if="tradeStatus"
              @click="updateTrade"
            >
              <v-icon
                class="pa-1"
                color="#2D8CFF"
                :small="$vuetify.breakpoint.smAndUp"
                >mdi-pencil</v-icon
              >
              <span style="color: #2d8cff" v-if="$vuetify.breakpoint.smAndUp"
                >Modify</span
              >
            </v-btn>
            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-capitalize"
              :class="$vuetify.breakpoint.smAndUp ? 'ml-3' : 'ml-3'"
              :width="$vuetify.breakpoint.xsOnly ? '21%' : '23%'"
              inner-height="40"
              v-if="tradeStatus"
              @click="deleteTrade"
            >
              <v-icon
                class="pa-1"
                color="#2D8CFF"
                :small="$vuetify.breakpoint.smAndUp"
                >mdi-delete</v-icon
              >
              <span style="color: #2d8cff" v-if="$vuetify.breakpoint.smAndUp"
                >Delete</span
              >
            </v-btn>
            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-none"
              :class="$vuetify.breakpoint.smAndUp ? 'ml-3' : 'ml-2'"
              :width="$vuetify.breakpoint.xsOnly ? '22%' : '21%'"
              inner-height="40"
              @click="exitRealTrade(trade_data, 'APPLY_SL')"
              v-if="allowed_actions.includes('APPLY_SL')"
            >
              <span style="color: #2d8cff"> Apply SL</span>
            </v-btn>

            <v-btn
              color="#F5F5F5"
              class="py-5 elevation-1 text-none"
              :class="$vuetify.breakpoint.smAndUp ? 'ml-4' : 'ml-2'"
              :width="$vuetify.breakpoint.xsOnly ? '22%' : '21%'"
              inner-height="40"
              @click="exitRealTrade(trade_data, 'APPLY_TG')"
              v-if="allowed_actions.includes('APPLY_TG')"
            >
              <span style="color: #2d8cff"> Apply TG </span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { isAuthenticated } from "../../common/commonFunctions.js";
import { getImgLink } from "../../common/commonFunctions.js";
import commonFunctions from "../../common/commonFunctions.js";
import Axios from "@/api/BaseAxios.js";
import LinkPreview from "@/components/Trade/LinkPreview.vue";
import TradeTralingTargets from "./TradeTralingTargets.vue";
import apiUrl from "@/common/apiUrl";
import helper from "@/helper";
export default {
  name: "TradeUserData",
  components: {
    "trade-form-detail": () => import("./TradeDetailForm.vue"),
    "trade-form": () => import("./TradeForm.vue"),
    "confirm-trade-delete-form": () => import("./ConfirmTradeDeleteForm.vue"),
    LinkPreview,
    "trade-user-data-group-row": () =>
      import("@/components/Trade/TradeUserDataGroupRow"),
    TradeTralingTargets,
    // ReportAndBlockUser: () =>
    //   import("@/components/BlockUser/ReportAndBlockUser"),
  },
  props: [
    "is_user_content",
    "trade_data",
    "show_button",
    "home",
    "showDivider",
    "show_more",
    "allowed_actions",
  ],
  // props: {
  //   is_user_content: {},
  //   trade_data: {},
  //   show_button: {},
  //   home: {},
  //   showDivider: {},
  //   show_more: {},
  //   allowed_actions: {
  //     type: Array,
  //   },
  // },
  data() {
    return {
      exitBtnLoader: false,
      featuredBtnLoader: false,
      watchlistLoader: false,
      trade_detail_form: {
        flag: false,
        id: null,
      },
      delete_data: {
        flag: false,
        id: null,
      },
      trade_form_data: {
        flag: false,
        trade_edit: true,
        id: null,
        trade_data: {},
      },
      trade_types: ["Active", "Inactive", "Closed"],
      reasons: [
        {
          name: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Unde, mollitia.",
          time: "23 April, 2021",
        },
      ],
      sebi_badge: require("@/assets/images/gold_check.svg"),
      tooltip: false,
      isFollowingUser: this.trade_data.is_following_user,
      loggedInProfile: {},
      profile_object: {},
    };
  },
  methods: {
    ...mapActions({
      snackBar: "snackBar/showSnack",
      toggleBlockUser: "blockUser/toggleModal",
      toggleTradeModal: "tradeData/toggleModal",
      toggleAddTradeModal: "addTrade/toggleTradeModal",
    }),
    getImg(link) {
      return getImgLink(link);
    },
    getUrl(text) {
      const str = text;
      const matches = str.match(/\bhttps?:\/\/\S+/gi);

      if (matches && matches.length >= 1) {
        return matches[0];
      } else {
        return false;
      }
    },
    copyTrade(item) {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login required for following action",
          color: "success",
          timeout: 4500,
        });
        this.$router.push({ name: "login" });
        return false;
      }
      if (item.status === "Closed") {
        // this.toggleTradeModal({
        //   show: true,
        //   type: "copy",
        //   id: item.id,
        // });
        this.toggleAddTradeModal({
          show: true,
          type: "copy",
          id: item.id,
        });
      } else {
        // this.toggleTradeModal({
        //   show: true,
        //   type: "copy",
        //   copyDetail: item,
        //   id: item.id,
        // });
        this.toggleAddTradeModal({
          show: true,
          type: "copy",
          id: item.id,
          copyDetail: item,
        });
      }
    },
    addOrRemoveToFeatured(item) {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login required for following action",
          color: "success",
          timeout: 4500,
        });
        this.$router.push({ name: "login" });
        return false;
      }
      this.featuredBtnLoader = true;
      const successHandler = (res) => {
        console.log(res);
        item.is_featured = !item.is_featured;
        this.trade_data = item;
        this.featuredBtnLoader = false;
        let msg;
        if (item.is_featured) {
          msg = "Trade added to featured sections successfully";
        } else {
          msg = "Trade removed to featured sections successfully";
        }
        this.snackBar({
          text: msg,
          color: "success",
          timeout: 4500,
        });
        this.eventBus.$emit("reload-trades");
      };
      const failureHandler = () => {
        this.featuredBtnLoader = false;
      };
      let formData = {};
      formData["id"] = item.id;
      formData["is_featured"] = !item.is_featured;
      formData["request_type"] = "featured";
      Axios.request_PATCH(
        apiUrl.PATCH_TRADE_DETAIL,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    viewTrade(id, event) {
      this.$logEvent(event);
      if (this.home) {
        this.trade_detail_form.flag = true;
        this.trade_detail_form.id = id;
      }
    },
    goToProfile(e, name) {
      console.log("lick", e.target.className.split(" ")[0], name);
      if (e.target.className.split(" ")[0] === "user__title") {
        if (this.is_same_user) {
          this.$router.push({
            name: "ProfilePage",
          });
        } else {
          this.$router.push({
            name: "OthersProfilePage",
            params: { id: this.trade_data.posted_by_id, name: name },
          });
        }
      }
      // }
    },
    shareTrade(id, posted_by, type, trade_name, user_id) {
      // console.log(user_id, "trade data", location.origin, posted_by);
      // console.log(navigator.webdriver);
      const title = "Covesto";
      const text = `Hello, ${posted_by} has shared a trade recommendation on Covesto. ${type} ${trade_name}
            To know more details and get live updates, follow the trade at `;
      // const url = `https://covesto.in/trade/${id}/${trade_name}`;

      const url = `${location.origin}/profile/${user_id}/${posted_by}/?trade_id=${id}&trade_name=${trade_name}`;
      // console.log(u_url);

      helper.shareLink(url, text, title);

      this.$logEvent("trade_card_share");
    },
    getDateFormatted(date) {
      // console.log(date);
      return this.moment.utc(date).local().format("DD-MMM-YYYY, LT");
    },
    updateTrade() {
      if (this.trade_data.status == "Inactive") {
        this.toggleAddTradeModal({
          show: true,
          type: "edit",
          id: this.trade_data.id,
        });
        this.$emit("close");
      } else {
        this.$emit("update-reasoning");
      }
    },
    deleteTrade() {
      this.delete_data.id = this.trade_data.id;
      this.delete_data.flag = true;
    },
    getTradeDetails(id) {
      const successHandler = (res) => {
        this.trade_data = res.data;
      };
      const errorHandler = (err) => {
        console.log(err);
      };
      Axios.request_GET(
        `api/trade/user-trade-detail/${id}`,
        {},
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    followUser(to_follow_id) {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to follow another User",
          color: "success",
          timeout: 4500,
        });
        this.$router.push({ name: "login" });
        return false;
      }
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.$emit("reloadTradeDetailForm", this.trade_data.id);
        this.isFollowingUser = true;
        this.showSnack({
          text: `${res.data.message}`,
          color: "success",
          timeout: 4500,
        });
        this.$logEvent("followed_profile");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_followed_profile");
        }
      };
      const data = {
        user_id: user_id,
        to_follow_id: to_follow_id,
      };
      const errorHandler = (err) => {
        this.showSnack({
          text: `${err.data.message}`,
          color: "success",
          timeout: 4500,
        });
      };
      Axios.request_POST(
        "/api/follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    unFollowUser(to_unfollow_id) {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to follow another User",
          color: "success",
          timeout: 4500,
        });
        return false;
      }
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.$emit("reloadTradeDetailForm", this.trade_data.id);
        this.isFollowingUser = false;
        this.showSnack({
          text: `${res.data.message}`,
          color: "success",
          timeout: 4500,
        });
        this.$logEvent("unfollowed_profile");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_unfollowed_profile");
        }
      };
      const data = {
        user_id: user_id,
        to_unfollow_id: to_unfollow_id,
      };
      const errorHandler = (err) => {
        this.showSnack({
          text: `${err.data.message}`,
          color: "success",
          timeout: 4500,
        });
      };
      Axios.request_POST(
        "/api/un-follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    exitTradeHandler(trade) {
      if (trade.is_real) {
        this.exitRealTrade(trade, "EXIT");
      } else {
        this.exitTrade(trade.id);
      }
    },

    exitRealTrade(item, tradeActions) {
      // console.log(item, "exit");
      let headers = {};
      let params = {};
      params["trade_id"] = item.id;
      params["order_type"] = item.order_type;
      params["trade_action"] = tradeActions;
      // params["auth_id"] = '';
      let config = {
        headers: headers,
        params: params,
      };
      this.tempAxios
        .post(apiUrl.EXIT_ORDER, {}, config)
        .then((res) => {
          this.triggerTransactionFLowSmallCase(
            res.data.resp.transactionId,
            res.data.auth_token,
            item.id,
            tradeActions
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    triggerTransactionFLowSmallCase(
      transactionID,
      authToken,
      trade_id,
      tradeActions
    ) {
      console.log(transactionID, authToken, trade_id);
      // const self = this;
      const gatewayInstance = new window.scDK({
        gateway: "covesto",
        smallcaseAuthToken: authToken,
        config: {
          amo: true,
        },
      });

      gatewayInstance
        .triggerTransaction({
          // ! Use valid transactionId here
          transactionId: transactionID,
        })
        .then((txnResponse) => {
          // console.log(txnResponse);
          commonFunctions.decode_smallcase_authtoken_and_send(
            txnResponse,
            trade_id,
            tradeActions
          );
          // self.updateRealTrade(txnResponse, trade_id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    updateRealTrade(txnResponse, trade_id) {
      const successHandler = (res) => {
        console.log(res);
      };
      const failureHandler = () => {};
      let formData = {};
      formData["id"] = trade_id;
      formData["entry_price"] = txnResponse.orderBatches[0].buyAmount;
      formData["status"] = "Closed";
      Axios.request_PATCH(
        apiUrl.PATCH_TRADE_DETAIL,
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    exitTrade(id) {
      this.exitBtnLoader = true;
      const successHandler = (res) => {
        this.trade_data = res.data.trade_detail;
        console.log(res);
        this.$emit("exitReload");
        this.exitBtnLoader = false;
      };
      const failureHandler = () => {
        this.exitBtnLoader = false;
      };
      let formData = {};
      formData["id"] = id;
      Axios.request_POST(
        "api/trade/exit-trade",
        formData,
        {},
        successHandler,
        failureHandler,
        false,
        true
      );
    },
    followTrade() {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to Follow this trade",
          color: "success",
          timeout: 4500,
        });
        this.$router.push({ name: "login" });
        return false;
      }
      this.watchlistLoader = true;
      // const self = this;
      const successHandler = (res) => {
        this.trade_data = res.data.result;
        this.$emit("reload-home-trades");
        this.$logEvent("trade_card_watchlist");
        // self.showSnack({
        //   text: "Watchlist updated",
        //   color: "success",
        //   timeout: 4500,
        // });
        this.watchlistLoader = false;
      };
      const errorHandler = (err) => {
        console.log(err);
        this.watchlistLoader = false;
      };
      // const data = {
      //   user_id: localStorage.getItem("user_id"),
      // };
      let user_id = localStorage.getItem("user_id");
      let params = {};
      params["follower_id"] = user_id;
      params["watcher_type"] = "trade";
      params["trade_id"] = this.trade_data.id;
      Axios.request_POST_PARAMS(
        apiUrl.WATCHLIST_ADD_ITEMS,
        {},
        params,
        {},
        successHandler,
        errorHandler,
        false,
        true
      );
    },
  },
  mounted() {
    // console.log(this.trade_data, "trade data from trade card");
    this.loggedInProfile["user_id"] = localStorage.getItem("user_id");
    this.loggedInProfile["profile_id"] = localStorage.getItem("profile_id");
    this.profile_object["id"] = this.trade_data.posted_by;
  },
  computed: {
    tradeStatusText() {
      if (this.trade_data.status == "Active") {
        return "Live";
      } else if (this.trade_data.status == "Inactive") {
        return "Upcoming";
      } else {
        return this.trade_data.status;
      }
    },
    is_small_screen() {
      var w = window.innerWidth;
      if (w < 768) {
        return true;
      } else {
        return false;
      }
    },
    trade_pandl_data() {
      if (this.trade_data.pl_data > 0) {
        return "greenColor";
      } else if (this.trade_data.pl_data < 0) {
        return "redColor";
      } else {
        return "greyColor";
      }
    },
    pandlTitle() {
      if (this.trade_data.status === "Inactive") {
        return "Profit Potential";
      } else if (this.trade_data.status === "Active") {
        return "Current P&L";
      } else if (this.trade_data.status === "Closed") {
        return "Realized P&L";
      }
      return "";
    },
    pl_dataPercent() {
      return this.trade_data.pl_data;
    },
    pl_dataIcon() {
      if (this.trade_data.pl_data > 0) {
        return "mdi-arrow-up";
      } else if (this.trade_data.pl_data < 0) {
        return "mdi-arrow-down";
      } else {
        return "";
      }
    },
    pandlContent() {
      if (this.trade_data.status == "Active") {
        return "P & L of the live trade as per the entry price";
      } else if (this.trade_data.status == "Inactive") {
        return "Profit that can be earned through this trade.";
      } else if (this.trade_data.status == "Closed") {
        return "P & L of the past trade.";
      } else {
        return "P & L of the expired trade";
      }
    },
    infoIconColor() {
      if (this.trade_data.status == "Active") {
        return "#27ae60";
      } else if (this.trade_data.status == "Inactive") {
        return "#2f80ed";
      } else if (this.trade_data.status == "Closed") {
        return "#eb5757";
      } else {
        return "#f2f2f2";
      }
    },
    setChipClass() {
      return "chip-" + this.trade_data.status;
    },

    statusContent() {
      if (this.trade_data.status == "Active") {
        return "This is a live trade. Market entry was done on the Entry Price. Hold until Exit Price. Book profit/Cut loss on Target Price/Stop Loss";
      } else if (this.trade_data.status == "Inactive") {
        return "This is an upcoming trade and is not Live yet. Market entry to be done on the Entry Price.";
      } else {
        return "This is a past trade";
      }
    },
    profitLossPercent() {
      return this.trade_data.profit_percent;
    },

    profitLossIcon() {
      if (this.trade_data.profit_percent > 0) {
        return "mdi-arrow-up";
      } else {
        return "mdi-arrow-down";
      }
    },
    incrementDecrementIcon() {
      if (this.trade_data.price_up_down > 0) {
        return "mdi-plus";
      } else {
        return "mdi-minus";
      }
    },

    incrementDecrementData() {
      return this.trade_data.price_up_down;
    },
    is_same_user() {
      const user_id = localStorage.getItem("user_id");
      return Number(user_id) === Number(this.trade_data.posted_by_id);
    },

    tradeStatus: function () {
      return this.trade_data.status === "Inactive";
    },
    isTradeLive: function () {
      return this.trade_data.status === "Active";
    },
    is_posted_by_user() {
      const user_id = localStorage.getItem("profile_id");
      return Number(this.trade_data.posted_by) == Number(user_id);
    },
  },
};
</script>
<style scoped>
.btnClass {
  border-radius: 6px;
}
.btnClass >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  color: #ffffff;
  letter-spacing: 0px;
}
.activeBtnClass {
  border-radius: 6px;
}
.activeBtnClass >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  /* identical to box height */

  text-align: center;

  color: rgba(51, 51, 51, 0.7);
  letter-spacing: 0px;
}
</style>
<style lang="scss" scoped>
.user__title {
  cursor: pointer;
  color: #333333;
}

.copyText {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #606060;
}
.copyMainText {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;

  color: #000000;
}

@media all and (max-width: 600px) {
  .user-content {
    padding: 10px !important;
    background-color: #f6f7fa;
  }
  .user-title {
    padding-left: 10px !important;
    font-size: 12px;
  }
  .title-and-chip {
    padding: 0px 10px !important;
  }

  .profile-pic {
    height: 55px !important;
    width: 55px !important;
  }
  .profile_avatar {
    height: 50px !important;
    width: 40px !important;
  }
  h2 {
    font-weight: bolder;
    font-size: 15px;
    white-space: nowrap;
  }
  .title-span {
    font-size: 15px !important;
  }
  .live-figures-div,
  .title-and-chip {
    padding: 10px !important;
  }
  .live-figures-div {
    padding: 0px 10px !important;
  }
  .figures {
    justify-content: flex-start;
    width: 69% !important;
    padding: 0px !important;
  }
  .figures-container {
    padding: 10px !important;
  }
  .price {
    width: 22% !important;
  }
  .reasoning {
    padding: 10px !important;
  }
  .cta-btn {
    font-size: 10px !important;
  }
  .cta-btn-text {
    display: none !important;
  }
  .live-price {
    font-size: 14px !important;
  }
  .cta-buttons {
    background: #f6f7fa !important;
  }
  .chip-Inactive,
  .chip-Closed,
  .chip-Active {
    font-size: 12px !important;
  }
  .custom-chip-buy,
  .custom-chip-sell {
    font-size: 20px;
    width: 20% !important;
  }
}

.user-content {
  display: flex;
  align-items: center;
  padding: 20px;
  background-color: #f6f7fa;
}
.follow-btn {
  display: flex;
  cursor: pointer;
  color: #2d8cff;
  font-weight: 800;
  font-size: 16px;
  align-items: center;
}
.chip-Inactive {
  background: rgba(47, 128, 237, 0.2) !important;
  font-size: 14px;
  color: #2f80ed;
}
.greyColor {
  color: #333333;
}
.chip-Closed {
  background: rgba(235, 87, 87, 0.2) !important;
  color: #eb5757;
}
.chip-Active {
  color: #27ae60;
  background: #ddeee8 !important;
  border-radius: 24px;
}
.user-title {
  width: 80%;
  padding-left: 20px;
}
.profile-pic {
  display: inline-block;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  object-fit: cover;
  text-align: center;
}
.profile__pic__avatar {
  height: 65px !important;
  width: 75px !important;
}
.title-and-chip {
  display: flex;
  padding: 1.5rem;
  padding-bottom: 0;
  margin: 0;
  justify-content: space-between;
}
.title-span {
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  width: 60%;
  font-weight: 900;
}
.custom-chip-buy {
  color: #2d8cff;
}
.custom-chip-sell {
  color: #eb5757;
}
.redColor {
  background: rgba(235, 87, 87, 0.2);
  color: #eb5757;
}
.greenColor {
  background: rgba(39, 174, 96, 0.12);
  color: #27ae60;
}
.redColor,
.greenColor {
  padding: 5px;
  border-radius: 3px;
  font-weight: 900px;
}
.pl-box-large {
  width: 85%;
  padding: 5px;
  border-radius: 3px;
  font-weight: 900px;
  font-size: 18px;
}
.pl-box-small {
  width: 100%;
  padding: 5px;
  border-radius: 3px;
  font-weight: 900px;
  font-size: 15px;
}

.custom-chip-buy,
.custom-chip-sell {
  font-weight: 800;
  font-size: 16px;
  width: 100% !important;
  text-transform: uppercase;
}

.live-figures-div {
  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
  align-items: center !important;
}
.figures {
  display: flex;
  // width: % !important;
  align-items: center;
  justify-content: space-between !important;
}
.live-price {
  font-weight: 800;
  font-size: 24px;
  color: #333333;
}
.profit-percent,
.loss-percent {
  border-radius: 3px;
  text-align: center;
  font-size: 13px !important;
  font-weight: bold;

  width: 70px !important;
}
.profit-percent {
  /*background: rgba(39, 174, 96, 0.12);*/
  color: #27ae60;
}
.increment {
  color: #27ae60;
}

.increment,
.decrement {
  padding-top: 5px;
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
}
.decrement {
  color: #eb5757;
}
.loss-percent {
  /*background: rgba(235, 87, 87, 0.2);*/
  color: #eb5757;
}
.figures-container {
  display: flex;
  padding: 20px;
  flex-direction: row;
  flex-wrap: wrap !important;
  width: 100% !important;
  justify-content: stretch;
}
.price {
  display: flex;
  flex: 0 0 33.333333%;
  flex-direction: column;
  justify-content: center;

  padding-top: 10px;
}
.price-span {
  color: rgba(51, 51, 51, 0.64) !important;
  font-size: 14px;
}
.reasoning {
  padding: 0px 20px;
}
.reason {
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}
.reason-time {
  color: grey;
  font-size: 13px;
}
.tooltip {
  background: #f7faff;
  opacity: 1 !important;
  // width: 25% !important;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px !important;
}
.tooltip-text {
  color: #333333 !important;
}
.figure {
  font-weight: 800 !important;
}
.new-figure {
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  color: #333333;
}
.cta-button {
  margin-left: 10px;
  text-transform: capitalize;
  color: #fff;
  letter-spacing: 0px;
  border-radius: 8px;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
}
.cta-icon {
  border-radius: 8px;
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  border: 1px solid #2d8cff;
}
.cta-button,
.cta-icon {
  margin: 0px 5px;
}
.cta-buttons {
  display: flex;
  border-top: 1px solid lightgray;
  justify-content: space-between;
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  height: 45px;
}
.cta-btn {
  padding: 10px 5px;
  height: 45px;
  width: 33%;
  font-size: 14px;
  text-align: center;
  color: rgba(51, 51, 51, 0.7);
  border-left: 1px solid lightgray;
}
.cta-btn-text {
  display: inline;
}
#sebi-tooltip {
  width: 10%;
  margin-left: 90px !important;
  background-color: lightblue;
}
#sebi-tooltip::after {
  content: " ";
  position: absolute;

  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent lightblue transparent;
}
#sebi-tooltip {
  font-size: 13px;
  text-align: center;
  position: relative;
  z-index: 1;
  padding: 5px;
  border-radius: 6px;
  position: fixed;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 1.2rem !important;
  word-break: break-all;
}
</style>
